import { LIMIT } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: LIMIT,
  params: {},
  needFetchFillInfo: true,
  view: {
    title: '添加限制说明',
    labelPosition: 'right',
    content: [
      {
        $id: 'limitDesc',
        $type: 'input',
        label: '限制说明',
        $el: {
          placeholder: '请输入限制说明',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '限制说明'
          }
        ]
      }
    ]
  }
}
